import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { employeeDomainType, organizationDomainType, planDomainType } from './LogList';

export interface Attribute {
  entityName: string;
  attributes: string[];
}

const LinkedTemplatesEntityName = 'LinkedTemplates';
const PlanAccountFundingConfigEntityName = 'PlanAccountFundingConfig';
const PlanCoverageConfigEntityName = 'PlanCoverageConfig';
const PlanPrimaryConfigEntityName = 'PlanPrimaryConfig';

interface AttributePayload {
  entity_name?: string;
  attributes?: string[];
}

const formatData = (data: AttributePayload[]) =>
  data.map((item) => ({
    entityName: item.entity_name || '',
    attributes: item.attributes || [],
  }));

interface Props {
  domain_types: string;
  lockbox_id?: string;
  employee_id?: string;
  plan_id?: string;
  organization_id?: string;
}

const useGetAttributesListQuery = (params: Props) => {
  const { data, isLoading, isSuccess } = useQuery([API_URL.ATTRIBUTES_LIST, params], () =>
    // TODO: missing type
    api.get<AttributePayload[]>(API_URL.ATTRIBUTES_LIST, { params })
  );

  const filteredFormattedData = useMemo(() => {
    const list = data?.data || [];
    switch (params.domain_types) {
      case employeeDomainType: {
        return list.filter(
          (item) =>
            item.entity_name !== PlanAccountFundingConfigEntityName &&
            item.entity_name !== PlanCoverageConfigEntityName &&
            item.entity_name !== PlanPrimaryConfigEntityName
        );
      }
      case planDomainType: {
        return list.filter((item) => item.entity_name !== LinkedTemplatesEntityName);
      }
      case organizationDomainType: {
        return list.filter(
          (item) =>
            item.entity_name !== PlanAccountFundingConfigEntityName &&
            item.entity_name !== PlanCoverageConfigEntityName &&
            item.entity_name !== PlanPrimaryConfigEntityName
        );
      }
      default: {
        return list;
      }
    }
  }, [params, data]);

  return {
    attributesList: formatData(filteredFormattedData) as Attribute[],
    isLoading,
    isSuccess,
  };
};

export default useGetAttributesListQuery;
